export default __webpack_public_path__ + "static/image-35-2038e33deb704d9981ef7853bf8448d8.jpg";